import { Module } from 'vuex';
import IRootState from '@/store/types/IRootState';
import CmsState from './types/CmsState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const cms: Module<CmsState, IRootState> = {
  namespaced: true,
  state: {
    cmsPages: [],
    cmsBlocks: [],
  },
  actions,
  getters,
  mutations,
};

export default cms;
